import React from 'react';
import { useTranslation } from 'react-i18next';
import { CollapseBlock, Spinner } from '../../../../common';
import { routes } from '../../../../../utils/helpers/ApiClient';
import { AppBarCMS } from '../../../../basic';
import {
  useLazyGetAttendanceExportQuery,
  useGetAttendancePointsOverviewQuery,
  useGetAttendancePointDetailForStudentQuery,
  useGetAttendanceTeacherSubjectsEventsQuery,
} from '../../../../../redux/services/attendance';
import AttendanceOverviewTable from './AttendanceOverviewTable.jsx';
import { FileExcelOutlined } from '@ant-design/icons';

const AttendanceOverviewPage = ({ mode = undefined }) => {
  const { t } = useTranslation();
  const isStudent = mode === 'student';

  const { data: attendancePoints, isLoadingMyEvents } =
    useGetAttendancePointsOverviewQuery(undefined, {
      skip: isStudent,
    });

  const { data: attendancePointsStudent, isLoadingStudent } =
    useGetAttendancePointDetailForStudentQuery(undefined, {
      skip: !isStudent,
    });

  const { data: subjects, isLoading: isLoadingSubjects } =
    useGetAttendanceTeacherSubjectsEventsQuery(
      {
        events: 'false',
        all: 'false',
      },
      { skip: isStudent },
    );

  const [triggerExport, { isLoadingExport }] =
    useLazyGetAttendanceExportQuery();
  const handleExport = async () => {
    try {
      const result = await triggerExport().unwrap();

      if (result.file) {
        // Convert base64 to Blob
        const byteCharacters = atob(result.file);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });

        // Download
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = result.filename || 'attendance_export.xlsx';
        document.body.appendChild(link);
        link.click();
        setTimeout(() => {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }, 100);
      }
    } catch (error) {}
  };

  const mainActions = [
    {
      permission: 'attendance-events.export',
      onClick: handleExport,
      title: t('Exportovať účasti'),
      icon: <FileExcelOutlined />,
    },
  ];
  return isLoadingMyEvents ||
    isLoadingStudent ||
    isLoadingExport ||
    isLoadingSubjects ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={t('Prehľad účastí')}
        backUrl={`${routes.cmsDashboard}`}
        backUrlTooltip={t('Nástenka')}
        permissionsBasic={'fast-links'} // TODO: Samuel Change permissions
        mainActions={
          attendancePoints === undefined || attendancePoints.length === 0
            ? undefined
            : mainActions
        }
      />
      <div style={{ margin: '10px' }}>
        <CollapseBlock>
          <AttendanceOverviewTable
            subjects={subjects}
            attendanceEvents={
              isStudent ? attendancePointsStudent : attendancePoints
            }
          />
        </CollapseBlock>
      </div>
    </>
  );
};

export default AttendanceOverviewPage;
